import { render, staticRenderFns } from "./WechatApplymentWizard.vue?vue&type=template&id=13c04cd2&scoped=true"
import script from "./WechatApplymentWizard.vue?vue&type=script&lang=js"
export * from "./WechatApplymentWizard.vue?vue&type=script&lang=js"
import style0 from "./WechatApplymentWizard.vue?vue&type=style&index=0&id=13c04cd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c04cd2",
  null
  
)

export default component.exports